var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"home-toc card",attrs:{"aria-label":"On this page"}},[_c('h2',{staticClass:"home-toc-title"},[_vm._v("On this page")]),_vm._v(" "),_c('ul',{staticClass:"home-toc-list"},_vm._l((_vm.items),function(item){return _c('li',{key:item.id},[_c('a',{attrs:{"href":'#' + item.id}},[_vm._v(_vm._s(item.label))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }